import React, { useContext, useEffect, useState, useRef } from 'react';
import { Box, Typography, IconButton, Button, Container, Pagination, Tooltip, Checkbox, Divider } from '@mui/material';
import SendSharpIcon from '@mui/icons-material/SendSharp';
import CommonAccordion from '../../custom-components/CommonAccordion';
import CommonDownload from '../../custom-components/CommonDownload';
import SaveAltRoundedIcon from '@mui/icons-material/SaveAltRounded';
import ThumbDownIcon from '@mui/icons-material/ThumbDown';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { featureFiles, pseudoCode } from '../../../services/webServices'
import { TestCaseFlowDataContext } from '../../main-pages/TestAutomationPage';
import { useLocation, useNavigate } from "react-router-dom";
import CodeEditor from './CodeEditor';
import { LoadingModalContext } from "../../main-pages/ServicePage";
import ThumbUpOffAltIcon from "@mui/icons-material/ThumbUpOffAlt";
import ThumbDownOffAltIcon from "@mui/icons-material/ThumbDownOffAlt";
import ThumbUpOutlinedIcon from "@mui/icons-material/ThumbUpOutlined";
import ThumbDownOutlinedIcon from "@mui/icons-material/ThumbDownOutlined";
import ContentCopyOutlinedIcon from "@mui/icons-material/ContentCopyOutlined";
import { ReactComponent as GenerateButton } from "../../../images/generateButton.svg";
import CommonCopy from "../../custom-components/CommonCopy";



const FeatureFile = ({ title, isChecked, isExpanded, onCheckboxToggle, onExpandToggle }) => {
  
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        padding: '8px 8px',
        backgroundColor: isChecked ? '#b3d1ff' : 'white',
        marginLeft: '-10px',
        marginRight: '-40px',
        marginBottom: '2px',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <IconButton onClick={onExpandToggle}> {/* Use the prop to toggle expand/collapse */}
          {isExpanded ? <KeyboardArrowDownIcon /> : <KeyboardArrowRightIcon />}
        </IconButton>
        <Checkbox
          checked={isChecked}
          onChange={onCheckboxToggle}
        />
        <Typography variant="body2" sx={{ flexGrow: 1 }}>
          {title}
        </Typography>
      </Box>
      {isExpanded && (
        <>
          <Divider sx={{ borderColor: 'rgba(0, 0, 0, 0.1)', my: 2 }} />
        </>
      )}
    </Box>
  );
};

const LikeDislikeComponent = () => {
  const [liked, setLiked] = useState(false);
  const [disliked, setDisliked] = useState(false);

  const handleLike = () => {
    setLiked(prev => !prev);
    if (disliked) {
      setDisliked(false);
    }
  };

  const handleDislike = () => {
    setDisliked(prev => !prev);
    if (liked) {
      setLiked(false);
    }
  };

  const handleCopy = () => {
    // console.log("Content copied!");
  };

  return (
    <Box sx={{ display: 'flex', gap: '8px', marginTop: '8px' }}>
      <IconButton onClick={handleLike}>
        <ThumbUpIcon sx={{ color: liked ? 'blue' : 'inherit' }} />
      </IconButton>
      <IconButton onClick={handleDislike}>
        <ThumbDownIcon sx={{ color: disliked ? 'red' : 'inherit' }} />
      </IconButton>
      <IconButton onClick={handleCopy}>
        <ContentCopyIcon />
      </IconButton>
    </Box>
  );
};



const IconComponent = () => (

  <Box sx={{ maxWidth: 14, display: 'flex', flexDirection: 'column' }}>
    <img
      loading="lazy"
      src="https://cdn.builder.io/api/v1/image/assets/TEMP/74001bbbe35d84ed7dd44adbf23d2273b030df4d38296f54b84768e53b777ae2?placeholderIfAbsent=true&apiKey=61dcb7c26aae4febb0f66efb27027a73"
      alt=""
      style={{ width: '100%', objectFit: 'contain' }}
    />
  </Box>
);


const Feature = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const isDisabled = true;
  //  const { featureFiles, addPreferences } = useContext(TestCaseFlowDataContext);
  // const [featureFilesData, setFeatiuresFiles] = useState(featureFiles);
  // // console.log("featureFilesData====>", featureFilesData)
  const [downloadOpen, setDownloadOpen] = useState(false);
  const setLoading = useContext(LoadingModalContext);
  // // const { setShowPreferencesCompleted } = useContext(TestCaseFlowDataContext);

  // const [showPreferences, setShowPreferences] = useState(false);
  const [liked, setLiked] = useState(false);
  const [disliked, setDisliked] = useState(false);

  const [activeThumb, setActiveThumb] = useState(null);
  const [isCopied, setIsCopied] = useState(false);
  // console.log("addPreferences", props)
  const defaultFeatureFilesExpanded = props.projectType === "cypress-javascript" ? true : (props.featureFiles !== "" && !Object.keys(location.state?.generatedLocators ?? {}).length > 0);

  // Auto-scroll to this component when it appears
  // useEffect(() => {
  //   if (props.featureFile && props.featureFile !== "") {
  //     setTimeout(() => {
  //       const element = document.querySelector('[data-feature-component]');
  //       if (element) {
  //         element.scrollIntoView({ behavior: 'smooth', block: 'start' });
  //       }
  //     }, 100);
  //   }
  // }, [props.featureFile]);

  // useEffect(() => {
  //   setFeatiuresFiles(featureFiles);
  // }, [featureFiles]);

  const handleDownloadClick = () => {
    setDownloadOpen(true);
  };

  const handleCloseDownload = () => {
    setDownloadOpen(false);
  };

  // const handlePageSource = async () => {
  //   setLoading(true);
  //   //setGlobalLoading(true);

  //   try {
  //     navigate(location.pathname, { state: { ...location.state, pageSource: true }, replace: true });
  //     // Simulate a delay for loader visibility
  //     await new Promise((resolve) => setTimeout(resolve, 1500));
  //   } finally {
  //     setLoading(false);
  //     //setGlobalLoading(false);
  //   }
  // };
  const handlePageSource = () => {
    navigate(location.pathname, { state: { ...location.state, pageSource: '' }, replace: true })
  };


  const handleDownload = () => {
    // console.log("Download clicked...");
  };
  const handleLike = () => {
    setLiked(!liked);
    if (disliked) setDisliked(false);
  };

  const handleDislike = () => {
    setDisliked(!disliked);
    if (liked) setLiked(false);
  };

  // const handleCopy =
  //   () => {
  //     const textToCopy = JSON.stringify(featureFilesData, null, 2);
  //     navigator.clipboard.writeText(textToCopy).then(() => {
  //       alert("Text copied to clipboard!");
  //     });
  //   };

  //   const handleCopyClick = () => {
  //     // Handle copy action (you can implement actual copying logic here)
  //     console.log("Content copied!"); // Placeholder for copy logic
  //     setIsCopied(true);
  //     // Reset the copied status after 2 seconds (optional)
  //     setTimeout(() => setIsCopied(false), 2000);
  // };

  const handleThumbClick = (thumbType) => {
    // Toggle thumbs based on the thumbType (like or dislike)
    setActiveThumb((prev) => (prev === thumbType ? null : thumbType));
  };



  return (
    <Box data-feature-component>

      <CommonAccordion
        summary={props.projectType === "cypress-javascript" ? "Test Files" : "Feature File"}
        details={
          <Box sx={{ backgroundColor: '#fff', borderRadius: 1, p: 2, marginTop: '-15px' }}>

            <CodeEditor codeContent={(() => {
              try {
                // Handle Cypress test files format: array of strings
                if (Array.isArray(props.featureFile)) {
                  return props.featureFile.join('\n');
                }
                // Handle other formats
                return props.featureFile;
              } catch (e) {
                return props.featureFile;
              }
            })()} setCodeContent={props.setFeatureFile} />

            <Container maxWidth={false} disableGutters>
              <Box
                display="flex"
                flexDirection="column"
                alignItems="flex-start"
                justifyContent="flex-start"
                maxWidth="557px"

              >


                <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2, marginTop: 2 }}>
                  <Tooltip title="Like" arrow>
                    <Box
                      onClick={() => handleThumbClick("like")}
                      sx={{
                        cursor: "pointer",
                        marginRight: 2, // Margin between the buttons
                        "&:hover": {
                          color: "#49A3FF", // Change color on hover
                        },
                      }}
                    >
                      {activeThumb === "like" ? (
                        <ThumbUpIcon sx={{ fontSize: "24px" }} /> // Filled thumbs up when clicked
                      ) : (
                        <ThumbUpOutlinedIcon sx={{ fontSize: "24px" }} /> // Outlined thumbs up by default
                      )}
                    </Box>
                  </Tooltip>

                  {/* Thumbs Down Button with Tooltip */}
                  <Tooltip title="Dislike" arrow>
                    <Box
                      onClick={() => handleThumbClick("dislike")}
                      sx={{
                        cursor: "pointer",
                        marginRight: 2, // Margin between the buttons
                        "&:hover": {
                          color: "#FF4842", // Change color on hover
                        },
                      }}
                    >
                      {activeThumb === "dislike" ? (
                        <ThumbDownIcon sx={{ fontSize: "24px" }} /> // Filled thumbs down when clicked
                      ) : (
                        <ThumbDownOutlinedIcon sx={{ fontSize: "24px" }} /> // Outlined thumbs down by default
                      )}
                    </Box>
                  </Tooltip>
                  <CommonCopy contentToCopy={(() => {
                    try {
                      // Handle Cypress test files format: array of strings
                      if (Array.isArray(props.featureFile)) {
                        return props.featureFile.join('\n');
                      }
                      // Handle other formats
                      return props.featureFile;
                    } catch (e) {
                      return props.featureFile;
                    }
                  })()} />


                  {/* Copy Button with Tooltip */}
                  {/* <Tooltip title={isCopied ? "Copied!" : "Copy"} arrow>
                    <Box
                      // onClick={handleCopyClick}
                      sx={{
                        cursor: "pointer",
                        "&:hover": {
                          color: "#49A3FF", // Change color on hover
                        },
                      }}
                    >
                      {isCopied ? (
                        <ContentCopyIcon sx={{ fontSize: "24px" }} /> // Filled copy icon when copied
                      ) : (
                        <ContentCopyOutlinedIcon sx={{ fontSize: "24px" }} /> // Outlined copy icon by default
                      )}
                    </Box>
                  </Tooltip> */}
                </Box>


              </Box>
            </Container>
          </Box>
        }


        buttons={[
          ...(props.projectType !== "cypress-javascript" ? [{
            label: 'Export',
            variant: 'text',
            startIcon: (
              <span
                style={{
                  opacity: isDisabled ? 0.5 : 1, // Dim the icon when disabled
                  pointerEvents: isDisabled ? 'none' : 'auto', // Disable interaction with the icon
                }}
              >
                <IconComponent />
              </span>
            ),
            sx: {
              textTransform: 'none',
              color: isDisabled ? 'rgba(0, 0, 0, 0.5)' : '#49A3FF', // Dim the text when disabled
              cursor: isDisabled ? 'not-allowed' : 'pointer',
            },
            disabled: isDisabled, // Disable the button entirely
          }] : []),
          { label: 'Download', onClick: handleDownloadClick, variant: 'text', startIcon: <SaveAltRoundedIcon />, sx: { textTransform: 'none' } },
          ...(props.projectType === "cypress-javascript" ? [
            { 
              label: 'Generate Project', 
              onClick: props.onGenerateProject, 
              variant: 'contained', 
              startIcon: <GenerateButton />, 
              sx: { textTransform: 'none', marginLeft: "auto" } 
            },
            { 
              label: 'Push to GitHub', 
              onClick: props.onPushToGitHub, 
              variant: 'contained', 
              startIcon: <GenerateButton />, 
              sx: { textTransform: 'none', marginRight: 1 },
              disabled: !props.zipBlob
            }
          ] : [])
        ]}



        type={"output"}
        fullScreenMode={true}
        defaultExpanded={defaultFeatureFilesExpanded}
      />
      {/* {showPreferences && <SetPseudoCodePreferences />} */}

      <CommonDownload open={downloadOpen} onClose={handleCloseDownload}
        serviceResponse={[{ heading: props.projectType === "cypress-javascript" ? "Test Files" : "Feature File", type: "text", data: (() => {
          try {
            // Handle Cypress test files format: array of strings
            if (Array.isArray(props.featureFile)) {
              return props.featureFile.join('\n');
            }
            // Handle other formats
            return props.featureFile;
          } catch (e) {
            return props.featureFile;
          }
        })() }]}
        serviceName={props.projectType === "cypress-javascript" ? "Test Files" : "Feature File"}
        wordData={[{ heading: props.projectType === "cypress-javascript" ? "Test Files" : "Feature File", type: "text", data: (() => {
          try {
            // Handle Cypress test files format: array of strings
            if (Array.isArray(props.featureFile)) {
              return props.featureFile.join('\n');
            }
            // Handle other formats
            return props.featureFile;
          } catch (e) {
            return props.featureFile;
          }
        })() }]}
        documents={['docx']}
      />

    </Box>
  );
};

export default Feature;
